import React from 'react';
import { useDispatch } from 'react-redux';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
//import { useParams } from 'react-router-dom';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/tools';
import { dispatch } from 'src/store';
import {
  fetchMegaMenu,
  fetchMegaMenuInfo,
  fetchSisterScContentPages,
  getCollapseValidationMsgDisplay,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  resetData,
  //submitContentHomepage,  submitContentShoppingCart,
  submitMegaMenu,
  validation,
} from './slice';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import MegaMenuStyle from './MegaMenuStyle';
import Menu from './Menus';
//import { getCurrentSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/tools';

const SalesChannelEditorMegaMenuPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const size = getCurrentSize();
  // console.log('size', size);
  const hideRightPart = true;
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded: _loaded,
    isOnPrimaryLanguage,
    // currentStyle,
  } = props;
  //console.log('salesChannelName', salesChannelName);
  const _d = useDispatch();
  //const _params: IParams = useParams();
  React.useEffect(() => {
    return () => {
      _d(resetData());
    };
  }, []);
  const _rightChild = (
    <RightConfigWrapper
      title={getI18n('general.sider.megaMenu')}
      wrapperClassName={hideRightPart ? 'wrapperWithoutLeft' : ''}
      elements={[
        ...(isOnPrimaryLanguage
          ? [
              {
                body: (
                  <React.Fragment>
                    <MegaMenuStyle />
                  </React.Fragment>
                ),
                key: 'rightTop',
              },
            ]
          : []),
        {
          body: (
            <React.Fragment>
              <Menu isPrimary={isOnPrimaryLanguage} />
            </React.Fragment>
          ),
          key: 'rightBottom',
        },
      ]}
    />
  );
  const _leftChild = <React.Fragment />;
  const leftChild = hideRightPart ? _rightChild : _leftChild;
  const rightChild = hideRightPart ? null : _rightChild;

  return (
    <React.Fragment>
      {_loaded && (
        <PageWrapper
          headerConfig={{
            hasModified,
            submit: submitData,
            salesChannelContentData: salesChannel || {},
            salesChannelName,
            onDiscard,
            onGoBack,
            // hasStyleSelect: true,
          }}
          hideRightPart={hideRightPart}
          withoutCollapse={hideRightPart}
          leftChild={leftChild}
          rightChild={rightChild}
        />
      )}
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelEditorMegaMenuPage, {
  getState,
  convertDataFromReduxToServer,
  submit: submitMegaMenu,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid, saleChannelUuid } = params;
    dispatch(
      fetchMegaMenu({
        uuid: contentUuid,
        params: qParams,
      }),
    );
    dispatch(
      fetchMegaMenuInfo({
        uuid: contentUuid,
      }),
    );
    dispatch(
      fetchSisterScContentPages({
        contentUuid: contentUuid,
        saleChannelUuid: saleChannelUuid,
      }),
    );
  },
});
